import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BrandSymbol from '../ui/BrandSymbol';


const Frame130: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const firstName = (location.state as { firstName?: string })?.firstName || 'Your';

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-900 to-slate-900 flex justify-center pt-7 pb-16 px-4 relative">
      <div className="relative bg-stone-50 rounded-md shadow-[0_0_16px_4px_rgba(49,49,33,0.20)] w-full max-w-[1130px] h-[777px] flex flex-col items-center">
        {/* Radial gradient */}
        <div className="absolute bottom-0 left-0 w-full h-72 bg-[radial-gradient(ellipse_177.34%_93.90%_at_48.58%_161.71%,_#65ADC1_0%,_#E7F2F6_100%)] pointer-events-none" />

        {/* Logo & heading */}
        <BrandSymbol size="3xl" showText={true} variant="dark" className="mt-10" />
        <h2 className="mt-4 font-sans text-lg font-semibold text-stone-800 text-center">{firstName}'s Estate Plan</h2>

        {/* Main prompt */}
        <div className="mt-12 max-w-[725px] flex flex-col items-start text-left px-4">
          <h3 className="font-display text-2xl font-bold text-cyan-900 mb-4">Ready to start building your estate plan?</h3>
          <p className="font-sans text-base font-medium text-stone-800 mb-8">Start with the questionnaire below, it should only take about 5 minutes.</p>

          {/* Questionnaire card */}
          <div className="w-full bg-stone-100 border border-stone-400 rounded-lg p-6 flex items-center cursor-pointer hover:bg-stone-200" onClick={() => navigate('/frame-132')}>
            <div className="mr-4 flex items-center justify-center w-4 h-4">
              {/* Heart icon */}
              <svg viewBox="0 0 24 24" fill="#ea580c" className="w-4 h-4">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            </div>
            <div className="flex-1">
              <p className="font-sans text-base font-semibold text-stone-800">Setup Your Plan</p>
              <p
                className="font-sans text-xs text-stone-500 underline cursor-pointer hover:text-stone-700"
                onClick={(e) => {e.stopPropagation(); navigate('/frame-132');}}
              >
                Setup your plan and add the basics before you begin
              </p>
            </div>
            <div className="flex items-center justify-center w-5 h-4">
              {/* Right arrow icon */}
              <svg viewBox="0 0 20 20" fill="#15803d" className="w-5 h-4">
                <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L13.586 11H3a1 1 0 110-2h10.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </div>
          </div>

          {/* Optional link to full task list */}
          <p className="mt-4 font-sans text-base text-stone-500">
            or{' '}
            <button onClick={() => navigate('/frame-140')} className="underline hover:text-stone-700">
              see the full list of tasks
            </button>
          </p>
                </div>
                
        {/* Floating progress */}
        <div className="absolute top-14 right-16 flex items-center gap-2">
          <div className="w-3.5 h-3.5 bg-neutral-200 rounded-full relative">
            <div className="absolute inset-0 m-auto w-1.5 h-[2.75px] bg-cyan-700 rotate-90" />
          </div>
          <span className="text-slate-400 text-xs font-medium">5% complete</span>
        </div>

        {/* Navigation buttons */}
        <div className="absolute bottom-8 left-0 right-0 px-16">
          <div className="flex justify-end items-center">
            <button
              onClick={() => navigate('/frame-132')}
              className="bg-cyan-700 hover:bg-cyan-800 text-stone-50 font-sans text-base font-medium px-6 py-2 rounded"
            >
              Get Started <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
        </div>
    </div>
  );
};

export default Frame130; 